import React from 'react';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './jds-toast.css';
import {
  AlertCircleIcon,
  AlertTriangleIcon,
  CheckCircleIcon,
  CloseIcon,
  InfoIcon,
} from './icons';

const TOAST_ICONS = {
  success: CheckCircleIcon,
  error: AlertCircleIcon,
  warning: AlertTriangleIcon,
  info: InfoIcon,
};

// react-toastify chama `icon` e `closeButton` como funções simples (sem hooks).
const renderIcon = ({ type }) => {
  const Icon = TOAST_ICONS[type] || InfoIcon;
  return <Icon />;
};

const renderClose = ({ closeToast }) => (
  <button
    type="button"
    className="jds-toast__close"
    aria-label="Fechar notificação"
    onClick={(e) => {
      e.stopPropagation();
      closeToast(e);
    }}
  >
    <CloseIcon />
  </button>
);

// Container de toasts do Jusfy DS. A API `toast.success/error/warn/info` do
// react-toastify segue igual; só o visual (jds-toast.css, tokens JDS) mudou.
export function JdsToastContainer() {
  return (
    <ToastContainer
      className="jds-toast-container"
      toastClassName="jds-toast"
      position="top-right"
      autoClose={5000}
      limit={4}
      newestOnTop
      hideProgressBar
      pauseOnHover
      pauseOnFocusLoss
      transition={Slide}
      icon={renderIcon}
      closeButton={renderClose}
    />
  );
}
